export default {"src":"/_next/static/media/cro.37c68e94.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};